import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { updateUser } from "@actions/user";
import { Button } from "@components/library";
import { useTranslation } from "@helpers/translate";
import ChangePassword from "./ChangePassword";
import Authentication from "./Authentication";
import Sessions from "./Sessions";
import Notification from "./GlobalSettings/Notification";
import InlineOndato from "../InlineOndato";
import InlineTwoFactor from "./Authentication/InlineTwoFactor";
import "./index.sass";

export const SettingsTab = ({
  isMobile = false,
  inlinePopup = null,
  openInlinePopup = () => {},
  closeInlinePopup = () => {},
}) => {
  const {
    companyNews = 0,
    withdrawal = 0,
    deposit = 0,
  } = useSelector((state) => state.user.user);

  const dispatch = useDispatch();
  const { __ } = useTranslation();
  const [loading, setLoading] = useState(false);

  const { control, handleSubmit, formState, reset } = useForm({
    defaultValues: {
      companyNews: Boolean(Number(companyNews)),
      withdrawal: Boolean(Number(withdrawal)),
      deposit: Boolean(Number(deposit)),
    },
  });

  useEffect(() => {
    reset({
      companyNews: Boolean(Number(companyNews)),
      withdrawal: Boolean(Number(withdrawal)),
      deposit: Boolean(Number(deposit)),
    });
  }, [companyNews, withdrawal, deposit, reset]);

  const { isDirty } = formState;

  const handleNotificationSubmit = async (formData) => {
    setLoading(true);
    const data = {
      values: formData,
    };

    await dispatch(updateUser({ data }));
    reset(formData);
    setLoading(false);
  };

  // If on mobile and an inline popup is requested - render it instead of normal settings
  if (isMobile && inlinePopup === "ondato") {
    return (
      <div className="settings-page">
        <InlineOndato onClose={closeInlinePopup} />
      </div>
    );
  }

  if (isMobile && inlinePopup === "two-factor") {
    return (
      <div className="settings-page">
        <InlineTwoFactor
          onClose={closeInlinePopup}
          onSuccess={closeInlinePopup}
        />
      </div>
    );
  }

  return (
    <div className="settings-page">
      <div className="settings-page__notifications settings-page__notifications--mobile">
        <form onSubmit={handleSubmit(handleNotificationSubmit)}>
          <Notification control={control} />
          {isDirty && (
            <Button
              type="submit"
              className="settings__btn settings__btn--notifications"
              color="orange"
              size="middle"
              isLoading={loading}
              disabled={loading}
            >
              {__("settings.confirm")}
            </Button>
          )}
        </form>
      </div>

      <div className="settings-page__col">
        <Authentication isMobile={isMobile} openInlinePopup={openInlinePopup} />
      </div>

      <div className="settings-page__sessions">
        <Sessions />
      </div>
      <div className="settings-page__section">
        <ChangePassword />
      </div>
    </div>
  );
};

export default SettingsTab;
